export type FeedEventName =
    | "TreadItemCreated"
    | "TreadReload"
    | "ListItemAdded"
    | "ListReload"
    | "ListAddItems"
    | "PublicationDraftCreated"
    | "PublicationCreated"
    | "PublicationUpdate"
    | "QuestionCreated"
    | "AnswerCreated"
    | "ListCreated"
    | "PublicationRestored"
    | "PublicationPermanentlyDeleted"
    | "CardOwnPropsChanged"
    | "ChannelNewPublication"
    | "AuthorNewPublication"
    | "TopicNewPublication"
    ;

export type FeedCustomEventProps = CustomEventInit<string>;

type FeedEventLister = (e: FeedCustomEventProps) => void;

function subscribe(eventName: FeedEventName, listener: FeedEventLister) {
    document.addEventListener(eventName, listener);
}

function unsubscribe(eventName: FeedEventName, listener: FeedEventLister) {
    document.removeEventListener(eventName, listener);
}

function publish(eventName: FeedEventName, data: string) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}

export { publish, subscribe, unsubscribe };
